import { connect } from 'react-redux';
import { ensureBasketProducts } from 'apps/basket/actions/basket';
import { setNewMiniTrolleyPosition } from 'apps/header/actions/miniTrolley';

import MiniTrolley from 'apps/header/components/MiniTrolley';

export default connect(
  state => ({
    basket: state.basket,
    miniTrolley: state.header.miniTrolley,
  }), {
    ensureBasketProducts,
    setNewMiniTrolleyPosition,
  }
)(MiniTrolley);
